export class FrontHandleMetadata {
    VerticalAlign: VerticalSide = VerticalSide.Center;
    HorizontalAlign: HorizontalSide = HorizontalSide.Center;
    Orientation: EOrientation = EOrientation.Normal;
    Position: EHandlePosition = EHandlePosition.DefaultCenter;
}

export enum VerticalSide {
    Center,
    Top,
    Bottom,
}

export enum HorizontalSide {
    Center,
    Left,
    Right,
}

export enum EOrientation {
    Normal,
    Left,
    Right
}

export enum EHandlePosition {
    DefaultCenter, 
    DefaultVertical, 
    DefaultHorizontal,
    CenterVertical
}
